import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-aadhaar-kycdigilocker',
  standalone: true,
  imports: [CommonModule,LoaderComponent],
  templateUrl: './aadhaar-kycdigilocker.component.html',
  styleUrl: './aadhaar-kycdigilocker.component.scss'
})
export class AadhaarKYCDigilockerComponent {
  @Input() url: string = '';

  private childWindow: Window | null = null;
  private checkInterval: any;
  public windowClosed = new Subject<void>();
  isDisabled = true;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.openThirdPartyWindow(this.url);
  }

  openThirdPartyWindow(url: string, windowName = '_new', windowFeatures = 'width=800,height=600,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=no') {
    // Close any existing window
    if (this.childWindow && !this.childWindow.closed) {
      this.childWindow.close();
    }

    // Open new window
    this.childWindow = window.open(url, windowName, windowFeatures);

    if (this.childWindow) {
      // Start checking if window is closed
      this.startWindowMonitoring();
    }

    return this.childWindow;
  }

  private startWindowMonitoring() {
    this.checkInterval = setInterval(() => {
      if (this.childWindow && this.childWindow.closed) {
        this.handleWindowClosed();
      }
    }, 500); // Check every 500ms
  }

  private handleWindowClosed() {
    clearInterval(this.checkInterval);
    this.windowClosed.next();
    this.childWindow = null;
    this.isDisabled = false;
    this.close();
  }

  closeChildWindow() {
    if (this.childWindow && !this.childWindow.closed) {
      this.childWindow.close();
    }
  }

  close() {
    this.activeModal.close();
  }
}
